module.exports = __webpack_public_path__ + "13a67fa4dd0402b9a660801bfd654470.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/sm-420.webp
// module id = 537
// module chunks = 0